import { RootState } from '@app/store/types';

export const getUser = (state: RootState) => state.user;

export const getUserEmail = (state: RootState): string => state.user.user.email ?? '';

export const getUserIdentification = (state: RootState) => state.user.user.identification;

export const getUserBlockInfo = (state: RootState) => state.user.user.blockInfo;
